const SECONDS_PER_HOUR = 3_600;
const SECONDS_PER_MINUTE = 60;
const MS_PER_SECOND = 1_000;

const pad2 = (value: number): string => String(value).padStart(2, '0');

/**
 * The call's start, 12-hour with AM/PM whatever the browser's locale, as the
 * desktops show it ("10:14 AM"). Built from parts: newer browsers put a narrow
 * no-break space before "AM" in en-US.
 */
export function formatStartClock(start: Date): string {
  const parts = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).formatToParts(start);
  const part = (type: Intl.DateTimeFormatPartTypes): string => parts.find((p) => p.type === type)?.value ?? '';
  return `${part('hour')}:${part('minute')} ${part('dayPeriod').toUpperCase()}`;
}

/** The running counter: m:ss under an hour, then h:mm:ss (as on the desktops). */
export function formatElapsedClock(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / SECONDS_PER_HOUR);
  const minutes = Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
  const secs = seconds % SECONDS_PER_MINUTE;
  return hours >= 1 ? `${hours}:${pad2(minutes)}:${pad2(secs)}` : `${minutes}:${pad2(secs)}`;
}

/** Whole seconds from `start` to `now`, never negative. */
export function elapsedSeconds(start: Date, now: Date): number {
  return Math.max(0, Math.floor((now.getTime() - start.getTime()) / MS_PER_SECOND));
}
